var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:("fa " + _vm.size + " " + _vm.icon),style:(("color: " + _vm.color + ";")),attrs:{"aria-hidden":"true"}})}
var staticRenderFns = []

export { render, staticRenderFns }